/**
 * Get excise duty tax periods needed for month year selection component
 */

import { getToken } from "../utils";
import { BASE_URL } from "../endpoints";

const getTaxPeriods = async () => {
  const token = getToken();
  if (token) {
    try {
      const response = await fetch(`${BASE_URL}/api/metadata/tax_periods`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.status === 200) {
        const data = await response.json();
        return data.tax_periods;
      } else {
        return null;
      }
    } catch {
      return null; // network error
    }
  } else {
    return null; // No token or not admin
  }
};

export default getTaxPeriods;
